import {useStepperPaths} from './useStepperPaths'

export const useNextStepperPath = (currentPath: string): string => {
  const stepperPaths = useStepperPaths()

  const currentPathIndex = stepperPaths.findIndex((path) => currentPath === path)

  if (currentPathIndex === -1) {
    throw new Error(`Can't find current path '${currentPath}'`)
  }

  const nextPathIndex = currentPathIndex + 1

  if (nextPathIndex === stepperPaths.length) {
    throw new Error(`Incorrect usage`)
  }

  const nextPath = stepperPaths[nextPathIndex]

  if (!nextPath) {
    throw new Error(`Can't find next path for '${currentPath}'`)
  }

  return nextPath
}
